export default __webpack_public_path__ + "static/media/power_spectrum_dynamic_eeg.f0fa2d42.webp";